import React from "react";

import "./NormalizedSeries.scss";

const NormalizedSeries = props => {
  const getClassName = () => {
    const styleClass = "edit-normalize-filter-icon";
    return props.active ? `${styleClass}-active` : styleClass;
  };

  return (
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" className={getClassName()} disabled={props.disabled}>
        <g id="Edit_Normalize_Filters" data-name="Edit_Normalize_Filters" transform="translate(0.5 0.5)">
          <g id="Group_15141" data-name="Group 15141">
            <path id="margin" fill="#fff" stroke="#707070" opacity="0" d="M0 0H32V32H0Z" />
            <rect id="Rectangle_2924" data-name="Rectangle 2924" fill="none" width="32" height="32" />
            <path
              id="scatter_plot_black_24dp_1"
              data-name="scatter_plot_black_24dp 1"
              className="icon-fill"
              d="M6.417 16.5a3.667 3.667 0 1 1 3.667-3.667A3.666 3.666 0 0 1 6.417 16.5Zm0-5.5A1.833,1.833 0 1 0 8.25 12.833 1.839 1.839 0 0 0 6.417 11Zm3.667-1.833A3.667 3.667 0 1 1 13.75 5.5,3.666 3.666 0 0 1 10.083 9.167Zm0-5.5A1.833 1.833 0 1 0 11.917 5.5 1.839 1.839 0 0 0 10.083 3.667ZM15.217 19.8a3.667 3.667 0 1 1 3.667-3.667A3.666 3.666 0 0 1 15.217 19.8Zm0-5.5a1.833 1.833 0 1 0 1.833 1.833A1.839 1.839 0 0 0 15.217 14.3Z"
              transform="translate(5.25 5.166)"
            />
          </g>
        </g>
      </svg>
    </div>
  );
};

export default NormalizedSeries;
